import { EarlySettlementLoadingPlaceholder } from '@cp-shared-19/frontend-ui';
import { useContract } from 'components/contracts/useContract';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import React from 'react';
import { TotalEarlySettlementUi } from './ui/TotalEarlySettlementUi';
import { useMyProfile } from 'components/my-profile';

const TotalEarlySettlementWithHandlers = withLoadingAndNoConnectionHandler(TotalEarlySettlementUi);

export const TotalEarlySettlement: React.FC<{ contractId: string }> = ({ contractId }) => {
    const { data: contract, isLoading, loadingError } = useContract(contractId);
    const { data: myProfileData, isLoading: isLoadingProfile, loadingError: profileLoadingError } = useMyProfile();

    return (
        <TotalEarlySettlementWithHandlers
            isLoading={isLoading || isLoadingProfile}
            contract={contract}
            hasError={!!loadingError || !!profileLoadingError}
            loadingPlaceholder={<EarlySettlementLoadingPlaceholder withDividedContractHeader summaryElements={1} />}
            customerType={myProfileData?.identification?.customerType ?? ''}
        />
    );
};
